module.exports = __webpack_public_path__ + "img/checklist_desk_french.d6a93434.png";